import { render, staticRenderFns } from "./deduction.vue?vue&type=template&id=efdde93e&"
import script from "./deduction.vue?vue&type=script&lang=js&"
export * from "./deduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports